<!-- 库存上下限操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" append-to-body :close-on-click-modal="false" center width="60%" top="2rem">
            <el-form size="mini" label-position="top">
                <el-form-item label="缺货商品">
                    <el-input @focus="$refs['showSelectData'].openBox('businessGoodsList','bgmId','bgmId')" v-model.trim="sendDataInfo.bgmName">
                    </el-input>
                </el-form-item>
                <el-form-item label="是否自动维护">
                    <el-radio-group v-model="sendDataInfo.auto">
                        <el-radio-button :label="0">手动维护</el-radio-button>
                        <el-radio-button :label="1">自动维护</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="上限数量">
                    <el-input v-model="sendDataInfo.limdHighnum" type="number">
                    </el-input>
                </el-form-item>
                <el-form-item label="下限数量">
                    <el-input v-model="sendDataInfo.limdLownum" type="number">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
                <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
                <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
    name: "stockLimitAction",
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                auto: 0,
                bgmId: "",
                bgmName: "",
                limdHighnum: 0,
                limdLownum: 0,
                limdId: "",
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.limdHighnum = 0;
            this.sendDataInfo.limdLownum = 0;
            this.sendDataInfo.auto = 0;
            this.dataActionBox.actionType = 0;
            this.dataActionBox.showStatus = false;
        },

        async isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem(
                        "selectBusinessGoodsEntryInfo"
                    );
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.bgmId = dataInfo.bgmId;
                        this.sendDataInfo.bgmName = dataInfo.bgmName;
                    }
                    break;
            }
        },

        openBox(cate, oldData = "") {
            this.initActionBox();
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增库存上下限信息";
            } else {
                this.dataActionBox.boxTitle = "编辑库存上下限信息";

                this.sendDataInfo.auto = oldData.auto;
                this.sendDataInfo.bgmId = oldData.bgmId;
                this.sendDataInfo.bgmName = oldData.bgmName;
                this.sendDataInfo.limdHighnum = oldData.limdHighnum;
                this.sendDataInfo.limdLownum = oldData.limdLownum;
                this.sendDataInfo.limdId = oldData.limdId;
            }
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },
        async sendDataAction() {
            if (this.sendDataInfo.bgmId == "") {
                this.$message({
                    message: "请选择商品",
                    type: "error",
                });
                return false;
            }
            if (this.sendDataInfo.limdHighnum == "") {
                this.$message({
                    message: "请输入上限数量",
                    type: "error",
                });
                return false;
            }

            if (this.sendDataInfo.limdLownum == "") {
                this.$message({
                    message: "请输入下限数量",
                    type: "error",
                });
                return false;
            }

            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addStockLimit(
                    this.sendDataInfo
                );
            } else {
                var responseData = await this.$http.setStockLimit(
                    this.sendDataInfo
                );
            }

            if (responseData.status == 200) {
                this.initActionBox();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$parent.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}
.table_content_box {
    height: 500px !important;
    overflow-y: auto;
}
</style>